import React from 'react';

import {AiFeedbackTour} from 'src/modules/ai/tour/views/ai-feedback-tour';
import {AiReviewTour} from 'src/modules/ai/tour/views/ai-review-tour';
import {AttributeDescriptionGenerationTour} from 'src/modules/ai/tour/views/attribute-description-generation-tour';
import {EventCreationMode} from 'src/modules/event-create/constants';

export const eventUpdateSteps = [
    {
        selector: '.attribute-description-generation-tour',
        content: <AttributeDescriptionGenerationTour/>,
    },
    {
        selector: '.ai-review-tour',
        content: <AiReviewTour/>,
    },
    {
        selector: '.ai-feedback-tour',
        content: <AiFeedbackTour mode={EventCreationMode.update}/>,
    },
];
